import React, { useEffect, useState } from "react";
import { formulas } from "../data/snapshots.js";
import { formulaSampleOutput } from "../science/kernel.mjs";
import { EvidencePanel, Metric, MetricGrid, PageHeader, PillSelector } from "../components/ui.jsx";

export function FormulaLab({ selectedFormula, selectedFormulaId, setSelectedFormulaId }) {
  const [sampleInput, setSampleInput] = useState(selectedFormula.sampleInputs);
  const formulaOutput = formulaSampleOutput(selectedFormula.id, sampleInput);

  useEffect(() => {
    setSampleInput(selectedFormula.sampleInputs);
  }, [selectedFormula]);

  return (
    <section className="module">
      <PageHeader
        title="FORMULA LAB"
        muted="Reproducible math"
        subtitle="Every sample has explicit assumptions, units, and source chain."
      />
      <div className="module-grid">
        <EvidencePanel title="Formula registry" status="auditable" tone="blue" className="panel-large">
          <PillSelector
            items={formulas}
            selectedId={selectedFormulaId}
            onSelect={setSelectedFormulaId}
            className="formula-list"
          />
        </EvidencePanel>
        <EvidencePanel
          title={selectedFormula.name}
          status={selectedFormula.class}
          tone={selectedFormula.class.includes("heuristic") ? "amber" : "green"}
        >
          <code className="formula-code">{selectedFormula.expression}</code>
          <Metric label="Units" value={selectedFormula.units} />
          <Metric label="Confidence" value={selectedFormula.confidence} />
          <div className="formula-grid">
            {Object.entries(sampleInput).map(([key, value]) => (
              <label key={key}>
                {key}
                <input
                  type="number"
                  value={value}
                  step={Number.isInteger(value) ? "1" : "0.01"}
                  onChange={(event) =>
                    setSampleInput((current) => ({ ...current, [key]: Number(event.target.value) }))
                  }
                />
              </label>
            ))}
          </div>
        </EvidencePanel>
      </div>
      <EvidencePanel title="Output" status="computed" tone="blue">
        <MetricGrid metrics={Object.entries(formulaOutput).map(([key, value]) => ({ label: key, value: String(value) }))} />
      </EvidencePanel>
    </section>
  );
}
